import { SaveSearchStore } from 'common/data/save-search/store';
import { SaveSearchStoreFactory } from 'common/data/save-search/store.factory';

const service = SaveSearchStoreFactory();

export function SaveSearchStoreService(): SaveSearchStore {
  return service;
}
